import { getEventTracker } from '@libs/eventTracking'
import {
  getNextPagePropertyFor,
  getCurrentPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'
import { WebEventNames } from './common'
import { paths } from '@routes/header-paths'

/**
 * [Link to spec](https://github.com/popdaily/popdaily.tracking/blob/develop/tracking_events/events/web-header/web-header.menu.enter.settings.md)
 */
export function trackHeaderMenuEnterEditorSetting() {
  getEventTracker().track({
    name: WebEventNames.WEB_HEADER_MENU_ENTER_SETTING,
    properties: {
      currentPage: getCurrentPagePropertyFor(''),
      toPage: getNextPagePropertyFor({
        pageName: 'web-setting',
        pageUrl: window.location.origin + paths.setting,
      }),
    },
  })
}
